<template lang="pug">
section
  div(
    v-sortable=`{
      handler: '.placement',
      container: '.placements',
      callback: onSorted
    }`
    class='slick-container'
  )
    div(class='placements')
      div(v-for='(place, key) in list' :key='key' class='list-item')
        v-card(
          :color='place.points ? "green lighten-5" : "grey lighten-3"'
          class='my-3 placement'
          flat
          v-bind:class='place.placement_type'
        )
          v-list(dense)
            v-list-tile
              v-list-tile-avatar(color='white' size='32' dark )
                div(class='flat')
                  div(class='flat-num') {{ key + 1 }}
              v-list-tile-content
                v-list-tile-sub-title {{ place.placement_type == 'storage' ? 'клад.' : (place.placement_type == 'commercial' ? 'комм.' : 'кварт.')}}
              v-list-tile-action
                v-btn(flat icon small)
                  v-icon(small) drag_indicator
</template>

<script>
import { arraySwap } from '@/utils'
export default {
  props: ['placements'],

  data: () => ({
    list: []
  }),

  beforeMount() {
    this.list = this.placements
  },

  methods: {
    onSorted({ oldIndex, newIndex }) {
      this.list = arraySwap(this.list, oldIndex, newIndex)
      this.$emit('sort', [...this.list])
    }
  },

  watch: {
    placements(val) {
      this.list = val
    }
  }
}
</script>

<style scoped>
.placement {
  user-select: none;
  cursor: move;
}
.placement >>> .v-list {
  background: none;
}
.placement >>> .v-btn {
  pointer-events: none;
}
.placement >>> .v-btn:before,
.placement >>> .v-btn:after {
  display: none;
}
.placement >>> .v-list__tile__avatar {
  min-width: 46px;
}

.placement >>> .v-list__tile__action {
  min-width: 26px;
}

.list-item {
  z-index: 400;
}
.flat {
  line-height: 1;
}
.flat-tit {
  opacity: 0.5;
  font-size: 10px;
  margin-top: -1px;
}
.flat-num {
  opacity: 0.75;
  font-size: 15px;
  font-weight: 800;
}
.slick-container {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  overflow-y: auto;
  padding: 12px 24px;
}
</style>
